import angular from 'angular';
import {Picture, fixPictureData} from '../model/picture.js';
import {NotFoundWithBlocked} from 'acng/userPool/model/stock.js';
import {guard} from '@acng/frontend-rubicon';
import {ERROR_RESPONSE_BODY} from 'acng/core/model/backend.js';

angular
  .module('picturePool')

  .factory('Picture', ['http', 'HttpCache', (http, HttpCache) => {
    const pictures = new HttpCache({
      prefix: '/api/picture/picture/',
      useCdn: true,
      fnError: (err, id) => {
        if (err.status == 404 || err.status == -1) {
          return http().get('/api/picture/picture/blocked/' + id, {
            dontIntercept: true
          }).catch((error) => {
            if (error.status == 404) {
              ASSERT: guard(error.data, ERROR_RESPONSE_BODY);
              throw new NotFoundWithBlocked(error.data.code);
            }

            throw error;
          });
        }
        throw err;
      },
      fnResolve: res => {
        res.data.price = res.data.set.price;
        delete res.data.set;
        ASSERT: fixPictureData(res.data);
        return new Picture(res.data);
      }
    });

    Picture.get = function (id) {
      return pictures.get(parseInt(id));
    };

    Picture.cache = pictures;

    return Picture;
  }]);
